import React from 'react';

interface IThemeContext {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme: any;
}

export const ThemeContext = React.createContext<IThemeContext>({
  theme: {},
});

export const useThemeContext = () => {
  return React.useContext(ThemeContext);
};

export const ThemeContextProvider = ThemeContext.Provider;
